import { Injectable } from '@angular/core';

import { ApiService } from '../common';
import { API_ENDPOINT } from '../../configs';
import { CreateConsoleRoleDTO } from '../../models/dto/role-management.dto';

@Injectable({
  providedIn: 'root',
})
export class ConsoleRoleService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.consoleRole.controller,
    );
  }

  getDetails(roleId: number) {
    return this.http.get(
      API_ENDPOINT.consoleRole.controller + API_ENDPOINT.consoleRole.getDetails + roleId,
    );
  }

  getPermissionsByMenu() {
    return this.http.get(
      API_ENDPOINT.consoleRole.controller + API_ENDPOINT.consoleRole.getPermissionsByMenu,
    );
  }

  createRole(data: CreateConsoleRoleDTO) {
    return this.http.post(
      API_ENDPOINT.consoleRole.controller,
      data,
    );
  }

  updateRole(roleId: number, data: CreateConsoleRoleDTO) {
    return this.http.put(
      API_ENDPOINT.consoleRole.controller + roleId,
      data,
    );
  }

  deleteRole(roleId: number) {
    return this.http.delete(
      API_ENDPOINT.consoleRole.controller + roleId,
    );
  }

  getRoleDetailsByUser(userId: number) {
    return this.http.get(
      API_ENDPOINT.consoleRole.controller + API_ENDPOINT.consoleRole.getRoleDetailsByUser + userId,
    );
  }
}
